// UI percent <-> stored fraction for tenants.suta_rate (DECIMAL(8,6)). Integer math only.
export const PCT_RE = /^\d{1,2}(\.\d{1,4})?$/;     // "3.822", "10.3734", "15"
export function fractionToPercentText(f) {          // "0.038220" -> "3.822"; null/'' -> ''
  if (f === null || f === undefined || f === '') return '';
  const micros = Math.round(Number(f) * 1e6);
  if (!Number.isFinite(micros)) return '';
  return (micros / 1e4).toFixed(4).replace(/\.?0+$/, '');
}
export function percentTextToFraction(p) {          // "3.822" -> "0.038220"; invalid -> null
  const s = String(p ?? '').trim();
  if (!PCT_RE.test(s)) return null;
  const micros = Math.round(parseFloat(s) * 1e4);   // 4 decimals of percent = whole micro-units of fraction
  if (micros <= 0 || micros > 150000) return null;  // 0 excluded, 15% max
  return (micros / 1e6).toFixed(6);
}
export const WAGE_BASE_RE = /^\d{1,7}(\.\d{1,2})?$/;
